import React from "react";
import { TranslationsMap } from "../../pages/CountryPage/CountryPage";
import Logo, { LogoType } from "../Logo/Logo";
import AppDownload from "../AppDownload/AppDownload";
import "./DownloadTitle.css";

interface DownloadTileProps {
  translations: TranslationsMap;
}

const DownloadTile: React.FC<DownloadTileProps> = ({ translations }) => {
  return (
    <div>
      <div className="medium-layout ml-auto mr-auto">
        <div className="flex flex-col justify-center items-center w-full text-center">
          <div className="logo-container">
            <Logo type={LogoType.LogoOnly} />
          </div>
          <h1 className="donwload-title">
            {translations["landingPage.download.title"]}
          </h1>
          <AppDownload center={true} />
        </div>
      </div>
    </div>
  );
};

export default DownloadTile;
